import React from "react";
import ReactHlsPlayer from "react-hls-player";

const Streamplayer = props => {
    const { streamUrl } = props?.location?.state;
    return(
        <div>
            {
                streamUrl ?
                (
                    <ReactHlsPlayer 
                        url={streamUrl}
                        autoplay={false}
                        controls={true}
                        width="100%"
                        height="auto"
                    />
                ) :
                (
                    <div>
                        Stream is end.
                    </div>
                )
            }
        </div>
    )
}

export default Streamplayer;